var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M21.125 12l-8.831-8.831v5.299H2.875v7.064h9.419v5.299z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }